import React from 'react';
import { IMitekCaptureResult, useMitekContext } from '../../../providers/MitekProvider/MitekProvider';
import './Passport.css';

import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import SessionStorage from '../../../utils/SessionStorage';
import { useMitekSubmit } from '../../../providers/MitekProvider/MitekDocumentsSubmit';
import { useMitekSubmit as useMitekSubmitModern } from '../../../providers/MitekProvider/MitekDocumentsSubmitModern';
import { IMitekFlowComponentProps } from '../MitekFlow';
import { DynamicResponse } from 'utils/api-utils/api-utils';
import { VerifyIdentificationDocumentResponse } from 'types/responses/VerifyIdentificationDocumentResponse';
import { Button, Row, Col, Image, Container } from '../../../importCL';


export interface IPassportProps extends IMitekFlowComponentProps {}

const Passport = (props: IPassportProps) : JSX.Element => {
    const { startCapture, MitekConfiguration, MitekProps } = useMitekContext();
    const { fullMitekSubmit } = useMitekSubmit();
    const { fullMitekSubmit: fullMitekSubmitModern } = useMitekSubmitModern();

    const captureCallback = async (result: IMitekCaptureResult) => {
        if (result.successful) {
            const selfieRequired = SessionStorage.get('useFaceBiometric');
            if (selfieRequired && selfieRequired === 'true') {
                props.setFlowStage('Selfie');
            } else {
                props.setSpinning(true);
                await ( MitekProps.usingModernApi ? fullMitekSubmitModern : fullMitekSubmit )({
                    onFailure: (
                        response?: DynamicResponse<VerifyIdentificationDocumentResponse>,
                    ) => {
                        if (response?.data?.IsRetake === true) {
                            props.setFlowStage('ResultsFailure');
                            props.setSpinning(false);
                        }
                    },
                    onSuccess: (
                        response?: DynamicResponse<VerifyIdentificationDocumentResponse>,
                    ) => {
                        if (response?.data?.IsRetake === true) {
                            props.setFlowStage('ResultsFailure');
                            props.setSpinning(false);
                        } else if (!MitekConfiguration.current.isMobileOnlySession) {
                            props.setFlowStage('ResultsSuccess');
                            props.setSpinning(false);
                        }
                    },
                });
            }
        }
    };

    const handleOnClick = () => {
        startCapture(captureCallback);
    };

    return (
        <Container id='mitek-flow-drivers-license' className='MitekFlowPassport MitekFlowPassport__container'>
            {props.mainTitle &&  
                <Row>
                    <Col>
                        <div className='MitekFlowPassport__mainTitle'>{props.mainTitle}</div>
                    </Col>
                </Row>
            }
            {props.subtitle && 
                <Row>
                    <Col>
                        <div className='MitekFlowPassport__subtitle'>{transformHTMLParserLinks(props.subtitle)}</div>
                    </Col>
                </Row>
            }
            {props.imgPath &&
                <Row>
                    <Col>
                        <Image 
                            loading='lazy'
                            className='MitekFlowPassport__mainImage'
                            src={props.imgPath}
                            alt={props.imgAltText}
                        />        
                    </Col>
                </Row>
            }
            {props.description &&
                <Row>
                    <Col>
                        <div className='MitekFlowPassport__description'>{transformHTMLParserLinks(props.description)}</div>
                    </Col>
                </Row>
            }
            <Row>
                <Col>
                    <Button 
                        className='MitekFlowPassport__ctaButton' 
                        onClick={handleOnClick} 
                        size='medium'>
                        {props.ctaButtonText}
                    </Button>
                </Col>
            </Row>
        </Container>);
};

export default Passport;